var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E2F5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 21C27.2091 21 29 22.7909 29 25C29 27.2091 27.2091 29 25 29C22.7909 29 21 27.2091 21 25H19C19 27.2091 17.2091 29 15 29C12.7909 29 11 27.2091 11 25C11 22.7909 12.7909 21 15 21C16.4805 21 17.7732 21.8043 18.4648 22.9999H21.5352C22.2268 21.8043 23.5195 21 25 21ZM15 23C13.8954 23 13 23.8954 13 25C13 26.1046 13.8954 27 15 27C16.1046 27 17 26.1046 17 25C17 23.8954 16.1046 23 15 23ZM25 23C23.8954 23 23 23.8954 23 25C23 26.1046 23.8954 27 25 27C26.1046 27 27 26.1046 27 25C27 23.8954 26.1046 23 25 23ZM24 11C26.2091 11 28 12.7909 28 15V18H30V20H10V18H12V15C12 12.7909 13.7909 11 16 11H24ZM24 13H16C14.9456 13 14 13.95 14 15V18H26V15C26 13.9456 25.05 13 24 13Z",
    fill: "#6FCBD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassOn);
export default __webpack_public_path__ + "static/media/glass-on.2762a0819424b51ed9a1a90db025c20b.svg";
export { ForwardRef as ReactComponent };